import React from 'react';

import { CliveAvatar } from '~/components/Clive/CliveAvatar';
import Avatar from '~/components/ui/atoms/Avatar';
import cn from '~/Utils/cn';

export const AiAvatar: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <Avatar className={cn('bg-transparent', className)}>
      <CliveAvatar mood={CliveAvatar.MOOD.HAPPY} size={32} />
    </Avatar>
  );
};
